export default {
  init: function () {
    document.addEventListener("mousedown", () => {
      document.body.classList.add("mouse-focus")
    })

    document.addEventListener("keydown", (e) => {
      if (
        (e.target.nodeName === "INPUT" || e.target.nodeName === "TEXTAREA") &&
        e.keyCode !== 9
      )
        return

      document.body.classList.remove("mouse-focus")
    })
  },
}
